var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"office-preview"},[_c('div',{staticClass:"container-in clearfix"},[_c('div',{staticClass:"iframe-wrap"},[_c('iframe',{attrs:{"id":"iframe","src":_vm.url,"frameborder":"0","width":"100%","height":"690px","allowfullscreen":"true"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-423665e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/preview/components/CZipPreview.vue
// module id = null
// module chunks = 